import React from "react";
import { Share2 } from "lucide-react";
import InsightCard from "@/components/share/InsightCard";

export default function Insights() {
  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12" data-testid="insights-page">
      <div className="grid lg:grid-cols-2 gap-10 items-start">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-emerald-600 mb-2 flex items-center gap-1.5"><Share2 size={13} /> Shareable insights</p>
          <h1 className="font-display text-4xl sm:text-5xl text-slate-900 leading-[0.95]" style={{ fontWeight: 900 }}>State of Management, from the people who report to it.</h1>
          <p className="text-slate-600 mt-5 leading-relaxed">
            Live, site-wide rankings of the eight leadership traits and the most-flagged manager behaviors — filterable by industry sector.
            Every number is an aggregate of anonymous employee reviews; no individual or small team is ever identifiable.
          </p>
          <p className="text-slate-600 mt-3 leading-relaxed">
            Pick a sector, then tap <b>Share to Social</b> to post the card straight to LinkedIn, TikTok, or Instagram — or download it as a PNG.
          </p>
          <div className="mt-6 bg-slate-50 border border-slate-200 rounded-xl p-4 text-sm text-slate-500 leading-relaxed">
            Supervisor and company pages have their own share cards — look for the <b>Share card</b> button on any profile that has passed the 5-review threshold.
          </div>
        </div>
        <InsightCard />
      </div>
    </div>
  );
}
